import { render, staticRenderFns } from "./RendirExamenes.vue?vue&type=template&id=0a850b97&scoped=true"
import script from "./RendirExamenes.vue?vue&type=script&lang=js"
export * from "./RendirExamenes.vue?vue&type=script&lang=js"
import style0 from "./RendirExamenes.vue?vue&type=style&index=0&id=0a850b97&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a850b97",
  null
  
)

export default component.exports